import { CASRoutingGroups } from '../../../cimsPage/instances/cas'
import { CreateViewEditSoftRemoveRestore } from '../../common'

const routingGroups = CreateViewEditSoftRemoveRestore({
  object: 'Routing Group',
  page: CASRoutingGroups,
  create: '00244175-e44d-4823-8071-cb9b8f12ff6a',
  view: '9358c3ee-7ad6-4704-b6aa-8e6f3c15cb43',
  edit: '7fd4c469-4db6-4157-884b-785a03a5f4c0',
  removeRestore: 'b21f44a3-3bd1-4253-b63b-9d2911534fbc',
})

export const CreateCASRoutingGroup = routingGroups.Create
export const ViewCASRoutingGroup = routingGroups.View
export const EditCASRoutingGroup = routingGroups.Edit
export const RemoveRestoreCASRoutingGroup = routingGroups.RemoveRestore

export type CASRoutingGroupPermission =
  | typeof CreateCASRoutingGroup
  | typeof ViewCASRoutingGroup
  | typeof EditCASRoutingGroup
  | typeof RemoveRestoreCASRoutingGroup
